/*
    创建者：shuxiaokai
    创建时间：2020-04-23 18:14
    模块名称：markdown组件
    备注：xxxx
*/
<template>
    <div class="s-markdown">
        <div class="toolbar">
            <div class="item" title="粗体">
                <i class="iconfont iconcuti"></i>
            </div>
            <div class="item" title="斜体">
                <i class="iconfont iconxieti"></i>
            </div>
            <div class="item" title="标题">
                <i class="iconfont iconbiaotizhengwenqiehuan"></i>
            </div>
            <div class="divider"></div>
        </div>
        <div class="px-3 py-3">
            <textarea slot="left" ref="text-wrap" class="text-wrap h-100"></textarea>
        </div>
    </div>
</template>

<script>
import Markdown from "markdown-it";
import CodeMirror from "codemirror"
import "codemirror/mode/markdown/markdown"
import "codemirror/lib/codemirror.css"
export default {
    data() {
        return {
            rawText: "",
            mdValue: "",
            mdInstance: null, //markdown实例
            cmInstance: null, //codemirror实例
        };
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        //=====================================初始化====================================//
        //初始化md和codeMirror
        init() {
            this.mdInstance = new Markdown();
            this.cmInstance = CodeMirror.fromTextArea(document.querySelector(".text-wrap"), {
                value: "222",
                mode: "markdown",
                autofocus: true,
                indentUnit: 4, //4格缩进
            });
            this.cmInstance.setOption("extraKeys", {
                Tab(cm) {
                    const spaces = Array(cm.getOption("indentUnit") + 1).join(" ");
                    cm.replaceSelection(spaces);
                }
            });

            this.cmInstance.on("change", (cm) => {
                console.log(cm.getValue())
                const value = cm.getValue();
                this.mdValue = this.mdInstance.render(value);
            });
            this.cmInstance.on("keyHandled", (cm, name, event) => {
                console.log(cm, name)
            })
            // this.cmInstance.setV;
        },
        //=====================================获取远程数据==================================//

        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//
        handleChangeText() {
            const result = this.mdInstance.render(this.rawText);
            console.log(result)
        },
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.s-markdown {
    width: 100%;
    height: 100%;
    border: 1px solid $gray-400;
    // 工具栏
    .toolbar {
        height: size(40);
        padding: 0 size(10);
        border-bottom: 1px solid $gray-400;
        display: flex;
        // 操作按钮
        .item {
            height: 100%;
            width: size(40);
            display: inline-flex;
            cursor: pointer;
            &:hover {
                background: $gray-400;
            }
            .iconfont {
                width: 100%;
                height: 100%;
                text-align: center;
                line-height: size(30);
                color: $gray-600;
            }
        }
        // 分割符号
        .divider {
            width: size(1);
            height: 60%;
            margin-top: size(7);
            background: $gray-400;
            display: inline-block;
        }
    }
}
</style>
